














































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import VueContext from 'vue-context'
import 'vue-context/src/sass/vue-context.scss'
import { Logical } from '@/types/logical'
import IconLogicalFolder from '@/components/icons/icon-logical-folder.vue'

export default Vue.extend({
  name: 'NavLogical',

  components: {
    VueContext,
    IconLogicalFolder,
  },

  data() {
    return {
      expand: false,
      contextTarget: {} as EventTarget,
      renamed: false,
      selected: {} as Logical,
    }
  },

  computed: {
    ...mapGetters({
      items: 'logical/navs',
    }),
  },

  async mounted() {
    await this.$store.dispatch('logical/find')
  },

  methods: {
    handleContext($event: Event) {
      this.renamed = true

      if ($event.currentTarget) {
        this.contextTarget = $event.currentTarget
      }
    },

    async handleAdd(type: string) {
      await this.$store.dispatch('logical/create', { type })
    },

    async handleClone() {
      const id = this.selected.id
      await this.$store.dispatch('logical/create', { id })
    },

    async handlePatch(l: Logical) {
      await this.$store.dispatch('logical/patch', { id: l.id, name: l.name })

      if (this.contextTarget instanceof HTMLElement) {
        this.contextTarget.classList.remove('rename')
      }

      this.renamed = false
    },

    async handleDelete() {
      const sId = this.selected.id
      const lId = this.$route.params.id

      let index = this.items.findIndex((l: Logical) => l.id === sId)

      await this.$store.dispatch('logical/delete', { id: sId })

      if (sId && !isNaN(parseInt(lId))) {
        if (parseInt(lId) === sId) {
          if (this.items.length === index) {
            index--
          }

          if (index >= 0) {
            const l = this.items[index]
            this.$router.push({ path: `/design/logical/${l.id}` })
          }
        }
      }
    },
  },
})
